export default __webpack_public_path__ + "static/media/cart-mini.d852e5a5.svg";